;
define("cookie_warning_banner_view.tpl", function(){});

